import { render, staticRenderFns } from "./NcmDetalhes.vue?vue&type=template&id=f6c24902"
import script from "./NcmDetalhes.vue?vue&type=script&lang=js"
export * from "./NcmDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports